import instance from '@apis/instance';
import {
  GetNotificationsParams,
  NotificationRow,
  UnreadResponse,
} from '@models/notification';
import { SliceResponse } from '@models/page';

class NotificationApi {
  static getNotifications(params: GetNotificationsParams): Promise<SliceResponse<NotificationRow>> {
    return instance.get('/notifications', { params });
  }

  static getHasUnread(): Promise<UnreadResponse> {
    return instance.get('/notifications/unread/exists');
  }

  static readAll(): Promise<never> {
    return instance.put('/notifications');
  }

  static read(notificationId: string): Promise<never> {
    return instance.put(`/notification/${notificationId}`);
  }
}

export default NotificationApi;
